/**
 * ANQ.ContentServiceManagement.API 
 * Content Service Mgt API
 *
 * OpenAPI spec version: v1
 * Contact: support@coure-tech.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface ServiceTransactionLogDto { 
    serviceId?: string;
    clientId?: string;
    operationCount?: number;
    phoneNumber?: string;
    channel?: string;
    transactionTimeStamp?: Date;
    service?: string;
    transactionRef?: string;
    status?: number;
}